import { EventBus } from "../../../eventbus";

export default {
  props: {
    initWidth: Number,
    initHeight: Number,
  },
  data() {
    return {
      opperationPrefix: "file-editor-preview",
      aspectRatio: 0,
      width: 0,
      height: 0,
      maxWidth: 0,
      maxHeight: 0,
    };
  },
  created() {
    this.setInit();

    EventBus.$on(`file-editor-preview--set-ratio`, (ratio) => {
      this.setRatio(ratio);
    });

    EventBus.$on(`image-dimensions--set-dims`, (dims) => {
      this.setDims(dims);
    });

    EventBus.$on(`file-editor-preview--reset`, () => {
      this.setInit();
    });
  },
  methods: {
    setInit() {
      this.width = this.initWidth;
      this.height = this.initHeight;

      this.maxWidth = this.initWidth;
      this.maxHeight = this.initHeight;

      this.setRatio();
    },
    setDims(dims) {
      const newRatio = dims.width / dims.height;

      //check if ratio has changed
      if (newRatio !== this.aspectRatio) {
        this.width = dims.width;
        this.height = dims.height;
        this.maxWidth = dims.width;
        this.maxHeight = dims.height;

        this.setRatio(dims.width / dims.height);
      }
    },
    setRatio(ratio = NaN) {
      if (isNaN(ratio)) {
        this.aspectRatio = this.width / this.height;
      } else {
        this.aspectRatio = ratio;
      }

      this.calcWidth();
      this.calcHeight();
    },
    calcWidth() {
      this.width = parseInt(this.height * this.aspectRatio);
      this.width = this.width > this.maxWidth ? this.maxWidth : this.width;
    },
    calcHeight() {
      this.height = parseInt(this.width / this.aspectRatio);
      this.height = this.height > this.maxHeight ? this.maxHeight : this.height;
    },
    handleInput(e, dim) {
      const val = Math.abs(e.currentTarget.value);

      if (dim === "width") {
        //is width
        this.width = val > this.maxWidth ? this.maxWidth : val;
        this.calcHeight();
        e.currentTarget.value = this.width;
      } else {
        //is height
        this.height = val > this.maxHeight ? this.maxHeight : val;
        this.calcWidth();
        e.currentTarget.value = this.height;
      }

      //send to file-editor-preview
      EventBus.$emit(`${this.opperationPrefix}--set-dims`, {
        width: this.width,
        height: this.height,
      });
    },
  },
};
